import styled from 'styled-components';

export const StyledBankPage = styled.div`
    display: flex;
    gap: 130px;
    align-items: flex-start;

    .credit-card-and-actions-block {
        min-width: 670px;
        width: 670px;

        form {
            display: flex;
            flex-direction: column;
            gap: 18px;
            align-items: center;

            .inputs-wrapper {
                display: flex;
                gap: 41px;
                width: 100%;
            }

            .full-width {
                width: 100%;
            }

            .app-btn {
                width: 300px;
                margin-top: 40px;
            }
          
            .clear-arrow {
                display: flex;
                justify-content: center;
                button {
                  background: #DBD6FB;
                  border: none;
                  border-radius: 50%;
                  width: 30px;
                  height: 30px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  cursor: pointer;
                  margin-top: 30px;
                }
            }
        }
    }
    .hidden-box {
      position: absolute;
      visibility: hidden;
      float: left;
      width: 1px;
      height: 1px;
      overflow: hidden;
    }
  
    @media screen and (max-width: 768px) {
        position: relative;

        .bank-img {
            position: absolute;
            z-index: 99;
            left: 50%;
            transform: translateX(-50%);
            top: -60px;
        }

        .credit-card-and-actions-block {
            min-width: unset;
            width: 90%;
            margin: auto;

            form {
                padding-top: 80px;

                .inputs-wrapper {
                    flex-direction: column;
                    gap: 20px;
                }
            }
        }
    }
`
